import React, { useState } from "react";
import {
    Avatar,
    IconButton,
    Tooltip,
    Typography,
    Menu,
    MenuItem,
    Divider,
    ListItemIcon,
    Modal,
    Box,
    Stack,
    Button,
    TextField,
    CircularProgress,
} from "@mui/material";
import { Logout, Person } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import toast from "react-hot-toast";
import * as api from "../../utils/api";

export default function AccountMenu() {
    const { currentUser, setUserDetails } = useAuth(); // Assuming setUserDetails is a method to update the currentUser state
    const [anchorEl, setAnchorEl] = useState(null);
    const [LoginOpen, setLoginOpen] = useState(false);
    const [newUserscreen, setNewUserScreen] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isSend, setIsSend] = useState(false);
    const [load, setLoad] = useState(false);
    const [successLog, setSuccessLog] = useState(false);

    const handleClickMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleSignout = () => {
        setUserDetails(null); 
        window.location.reload();
        toast.success("Logged out successfully");
    };
    const handleLoginOpen = () => setLoginOpen(true);
    const handleLoginClose = () => setLoginOpen(false);
    const handleChange = (e) => console.log(e.target.value);
    const formSubmit = (e) => { e.preventDefault(); alert("Form Submitted"); };

    // Sign in with email and password
    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);

        if (!email || !password) {
            toast.error("Please enter both email and password.");
            setLoad(false);
            return;
        }

        try {
            const response = await api.login_user(email, password);
            setLoad(false);
            if(response.data.user.role_id===3){
                setUserDetails(response.data.user,response.data.token); 
            setSuccessLog(true);
            window.location.reload();
            toast.success(response.data.message);
            }else{
                toast.error("User does not have access!");
            }
        } catch (error) {
            setLoad(false);
            if (error.response ) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message || "An error occurred during login.");
            }
        }
    };

    return (
        <>
            {currentUser ? (
                <>
                    <Tooltip title="Account Settings">
                        <IconButton
                            onClick={handleClickMenu}
                            size="small"
                            sx={{ ml: 2 }}
                            aria-controls={anchorEl ? "account-menu" : undefined}
                            aria-haspopup="true"
                        >
                            <Avatar sx={{ width: 32, height: 32 }} src="/broken-image.jpg" />
                        </IconButton>
                    </Tooltip>
                    <Menu
                        anchorEl={anchorEl}
                        id="account-menu"
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        PaperProps={{
                            elevation: 4,
                            sx: {
                                overflow: "visible",
                                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                mt: 1.5,
                                "& .MuiAvatar-root": {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                },
                                "&:before": {
                                    content: '""',
                                    display: "block",
                                    position: "absolute",
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: "background.paper",
                                    transform: "translateY(-50%) rotate(45deg)",
                                    zIndex: 0,
                                },
                            },
                        }}
                        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
                        transformOrigin={{ horizontal: "center", vertical: "top" }}
                    >
                        <Divider />
                        <MenuItem component={Link} to="/account">
                            <ListItemIcon>
                                <Person fontSize="small" />
                            </ListItemIcon>
                            <Typography variant="inherit" sx={{ fontWeight: 500 }}>
                                My Account
                            </Typography>
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={handleSignout}>
                            <ListItemIcon>
                                <Logout fontSize="small" sx={{ color: "red" }} />
                            </ListItemIcon>
                            <Typography variant="inherit" sx={{ color: "red", fontWeight: 500 }}>
                                Log Out
                            </Typography>
                        </MenuItem>
                    </Menu>
                </>
            ) : (
                <Typography
                    variant="subtitle1"
                    component="h6"
                    sx={{ cursor: "pointer" }}
                    onClick={handleLoginOpen}
                >
                    Log In
                </Typography>
            )}

            <Modal open={LoginOpen && !successLog} onClose={handleLoginClose}>
                <Box
                    sx={{
                        width: 400,
                        maxWidth: "90%",
                        margin: "auto",
                        mt: 4,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 3,
                        borderRadius: 2,
                    }}
                >
                    {!newUserscreen ? (
                        <Stack spacing={3} textAlign="center">
                            <Typography variant="h5" fontWeight="bold">
                                Login To <span style={{ color: "red" }}>KulaBox</span> Now
                            </Typography>
                            <Divider />
                            {!isSend ? (
                                <form onSubmit={handleLoginSubmit}>
                                    <Stack spacing={2}>
                                        {/* Email Input */}
                                        <TextField
                                            fullWidth
                                            required
                                            label="Email"
                                            name="email"
                                            type="email"
                                            color="error"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />

                                        {/* Password Input */}
                                        <TextField
                                            fullWidth
                                            required
                                            label="Password"
                                            name="password"
                                            type="password"
                                            color="error"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />

                                        {/* Login Button */}
                                        <Button
                                            variant="contained"
                                            color="error"
                                            type="submit"
                                            fullWidth
                                            disabled={load}
                                            startIcon={load && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {load ? "Logging in..." : "Login"}
                                        </Button>

                                        {/* Forgot Password Link */}
                                        <Button variant="text" sx={{ color: "error.main" }}>
                                            <Link
                                                to="/forgot-password"
                                                style={{ textDecoration: "none", color: "inherit" }}
                                            >
                                                Forgot Password?
                                            </Link>
                                        </Button>

                                        {/* Sign Up Link */}
                                        <Typography variant="body2" sx={{ mt: 2 }}>
                                            New User?{" "}
                                            <Link
                                                to="/create-account"
                                                style={{ textDecoration: "underline", color: "red" }}
                                            >
                                                Create Account
                                            </Link>
                                        </Typography>
                                    </Stack>
                                </form>
                            ) : null}
                        </Stack>
                    ) : (
                        <Stack spacing={3} textAlign="center">
                            <Typography variant="h5" fontWeight="bold" color="primary">
                                Signup
                            </Typography>
                            <Divider />
                            <form onSubmit={formSubmit}>
                                <Stack spacing={2}>
                                    <TextField
                                        fullWidth
                                        required
                                        label="Username"
                                        name="username"
                                        color="error"
                                        placeholder="Enter Your Name"
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        required
                                        label="Email"
                                        name="email"
                                        color="error"
                                        placeholder="Enter your email"
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        fullWidth
                                        required
                                        label="Mobile"
                                        name="mobile"
                                        color="error"
                                        placeholder="Enter your Mobile no"
                                        onChange={handleChange}
                                    />
                                    <Button variant="contained" color="primary" type="submit" fullWidth>
                                        Register
                                    </Button>
                                </Stack>
                            </form>
                        </Stack>
                    )}
                </Box>
            </Modal>
        </>
    );
}
